import React, { useRef, useState } from "react";
import PropTypes from "prop-types";

import storeReceivedCert from "services/backend/storeReceivedCert";
import useApiParams from "services/backend/useApiParams";

import Dropzone from "react-dropzone-uploader";
import Preview from "./components/Preview";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

export default function CustomDropzone(props) {
  const { updateStatus, onClose } = props;

  const { params: apiParams } = useApiParams();

  const chain = useRef();
  const certManagerCert = useRef();
  const rootCert = useRef();

  const [open, setOpen] = useState(false);
  const info = useRef();

  const setChain = (str) => {
    chain.current = str;
  };

  const setCertManagerCert = (str) => {
    certManagerCert.current = str;
  };

  const setRootCert = (str) => {
    rootCert.current = str;
  };

  const handleSubmit = (files, allFiles) => {
    info.current = null;
    if (!rootCert.current) {
      info.current = "No Root cert";
      setOpen(true);
      return;
    }
    if (!certManagerCert.current) {
      info.current = "No cert manager cert";
      setOpen(true);
      return;
    }
    storeReceivedCert(
      apiParams,
      certManagerCert.current,
      rootCert.current,
      chain.current
    )
      .then((res) => {
        if (res == "OK") {
          allFiles.forEach((f) => f.remove());
          chain.current = null;
          certManagerCert.current = null;
          rootCert.current = null;
          updateStatus();
          onClose();
        } else {
          info.current = "Did not add certificates to cert manager";
          setOpen(true);
        }
      })
      .catch((error) => {
        console.log("storeReceivedCert error", error);
        info.current = "Did not add certificates to cert manager";
        setOpen(true);
      });
  };

  const preview = (props) => {
    return (
      <Preview
        {...props}
        setChain={setChain}
        setCertManagerCert={setCertManagerCert}
        setRootCert={setRootCert}
      />
    );
  };

  /*
   */

  return (
    <>
      <Dropzone
        onSubmit={handleSubmit}
        PreviewComponent={preview}
        maxFiles={3}
        inputContent="Drop CertManagerCert, RootCert and Chain here"
        inputWithFilesContent={(files) =>
          `expecting ${3 - files.length} more file${
            3 - files.length > 1 ? "s" : ""
          }`
        }
        submitButtonDisabled={(files) => files.length < 2}
        submitButtonContent="Store the CertManager CRT, Chain and Root CRT"
        styles={{
          dropzone: {
            overflow: "hidden",
          },
          inputLabel: {
            color: "gray",
          },
          dropzoneActive: {
            backgroundColor: "lightgray",
            borderColor: "#C76700",
          },
          submitButton: {
            color: "white",
            backgroundColor: "#C76700",
          },
          inputLabelWithFiles: {
            color: "gray",
          },
        }}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>{info.current}</DialogContent>
      </Dialog>
    </>
  );
}

CustomDropzone.propTypes = {
  updateStatus: PropTypes.func,
  onClose: PropTypes.func,
};
